/**
 * @generated SignedSource<<04cfc32ea8039189358ea17395c4b6b6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type userAvailabilityConfigQueryFragment$data = {
  readonly findAvailabilityConfig: {
    readonly " $fragmentSpreads": FragmentRefs<"userAvailabilityConfigFragment">;
  } | null;
  readonly " $fragmentType": "userAvailabilityConfigQueryFragment";
};
export type userAvailabilityConfigQueryFragment$key = {
  readonly " $data"?: userAvailabilityConfigQueryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"userAvailabilityConfigQueryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "input"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": require('./userAvailabilitiesConfigRefetchableQuery.graphql')
    }
  },
  "name": "userAvailabilityConfigQueryFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "input"
        }
      ],
      "concreteType": "UserAvailabilityConfig",
      "kind": "LinkedField",
      "name": "findAvailabilityConfig",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "userAvailabilityConfigFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "fd26e5364d49c074b43ee381adc1b287";

export default node;
